// Setup everything needed (Globals - 3rd party or otherwise to get the app ready to initialize)
import '@netx/core/bootstrap';

// After i18n (success or fail) and custom css properties we will load the app
function loadApp() {
	// Initialize core
	import(/* webpackChunkName: "@netx/core" */ '@netx/core').then((Core) => {
		Core.default.initialize();
	});
}

import {initialize as i18ninit} from '@netx/core/i18n';
import css from '@netx/core/css';

// DAM-15140
// We cannot use Promise.finally due to iOS safari
// changing the babel config to handle this issue
// causes some weird things with plupload - not worth
// fighting at the moment - so, jQuery.Deferred it is
$.when(
	// Load custom CSS before loading in core
	css(),
	// Load i18n and base locales before loading in core
	i18ninit(),
)
	.then(
		() => {},
		(err) => {
			console.error(err);
		},
	)
	.always(() => {
		loadApp();
	});
